// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"SliderArrow_btn-primary__3OFNu","root":"SliderArrow_root__3RpwU"};